import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [license, setLicense] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("pnc_token"));
  const [loading, setLoading] = useState(true);

  const authFetch = axios.create({ baseURL: API });
  authFetch.interceptors.request.use((cfg) => {
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
    return cfg;
  });

  const loadLicense = useCallback(async (tkn) => {
    try {
      const r = await axios.get(`${API}/license/me`, { headers: { Authorization: `Bearer ${tkn}` } });
      setLicense(r.data);
    } catch { setLicense(null); }
  }, []);

  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }
    axios
      .get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(async (r) => {
        setUser(r.data);
        await loadLicense(token);
      })
      .catch(() => {
        localStorage.removeItem("pnc_token");
        setToken(null);
      })
      .finally(() => setLoading(false));
  }, [token, loadLicense]);

  const login = async (email, password) => {
    const r = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("pnc_token", r.data.token);
    setToken(r.data.token);
    setUser(r.data.user);
    await loadLicense(r.data.token);
  };
  const register = async (name, email, password) => {
    const r = await axios.post(`${API}/auth/register`, { name, email, password });
    localStorage.setItem("pnc_token", r.data.token);
    setToken(r.data.token);
    setUser(r.data.user);
    await loadLicense(r.data.token);
  };
  const logout = () => {
    localStorage.removeItem("pnc_token");
    setToken(null);
    setUser(null);
    setLicense(null);
  };
  const refreshUser = useCallback(async () => {
    if (!token) return;
    try {
      const r = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
      setUser(r.data);
      await loadLicense(token);
    } catch {}
  }, [token, loadLicense]);

  return (
    <AuthCtx.Provider value={{ user, license, token, loading, login, register, logout, refreshUser, api: authFetch, API }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
